module.exports = __webpack_public_path__ + "img/park.0e84ed93.png";